var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashiaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.000488281C22.4782 0.000488281 20.991 0.141551 19.5488 0.413172C17.3637 0.822855 15.2836 1.52817 13.3522 2.4856C5.43872 6.40985 0 14.5705 0 24.0007C0 37.2546 10.7439 47.9994 24 47.9994C37.2546 47.9994 48 37.2546 48 24.0007C48 10.7453 37.2546 0.000488281 24 0.000488281ZM23.979 6.95159C27.971 6.95159 31.6358 8.35922 34.5113 10.7108C37.3492 13.0293 39.4187 16.2647 40.2756 19.9699H31.5263C30.096 17.1952 27.2221 15.3013 23.9085 15.3013C19.1691 15.3013 15.3257 19.179 15.3257 23.9647C15.3257 24.9401 15.4847 25.8765 15.7789 26.7514C15.8029 26.8205 15.8269 26.8895 15.8524 26.957C13.4617 25.2132 11.9355 22.5661 11.9355 19.6022C11.9355 18.0235 12.3677 16.5364 13.1331 15.2263C13.3267 14.8931 13.5428 14.572 13.7784 14.2644L11.6578 12.408C14.7149 9.05403 19.1031 6.95159 23.979 6.95159ZM23.979 40.6942C15.0075 40.6942 7.68684 33.578 7.26513 24.6415C9.73237 30.1054 14.8034 33.8511 20.6548 33.8511C25.3582 33.8511 29.5543 31.432 32.3022 27.6473H40.2831C38.5648 35.1222 31.9165 40.6942 23.979 40.6942Z",
    fill: "#851EE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashiaLogo);
export default __webpack_public_path__ + "static/media/cashia_logo.990622688dd975ec548498ba2207549b.svg";
export { ForwardRef as ReactComponent };